module.exports = __webpack_public_path__ + "img/proj-5.635619a8.png";